import { render, staticRenderFns } from "./HealthcareMain.vue?vue&type=template&id=0e7c6f16&"
import script from "./HealthcareMain.vue?vue&type=script&lang=js&"
export * from "./HealthcareMain.vue?vue&type=script&lang=js&"
import style0 from "./HealthcareMain.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports